import { useState, useCallback, useRef } from 'react';

/**
 * Imperative-style dialogs (confirm / alert / prompt) for use instead of window.*.
 * @returns {{ dialog: object | null, resolve: function, confirm: function, alert: function, prompt: function }}
 */
export function useAppDialog() {
  const [dialog, setDialog] = useState(null);
  const resolveRef = useRef(null);

  const resolve = useCallback((value) => {
    const fn = resolveRef.current;
    resolveRef.current = null;
    setDialog(null);
    if (fn) fn(value);
  }, []);

  const confirm = useCallback((opts) => {
    return new Promise((res) => {
      resolveRef.current = res;
      setDialog({ type: 'confirm', ...opts });
    });
  }, []);

  const alert = useCallback((opts) => {
    return new Promise((res) => {
      resolveRef.current = res;
      setDialog({ type: 'alert', ...opts });
    });
  }, []);

  const prompt = useCallback((opts) => {
    return new Promise((res) => {
      resolveRef.current = res;
      setDialog({ type: 'prompt', ...opts });
    });
  }, []);

  return { dialog, resolve, confirm, alert, prompt };
}
